import type { FaireProductEntity } from "../../entity_types/product";

export const p_6dy2rh4a66: FaireProductEntity = {
  token: "p_6dy2rh4a66",
  type: "product",
  name: "Dessert First Recipe Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/8a49a167c06a1c7a8dea16960bf9466ce5ea84ac236f1520efdc08e3fc274168.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7d524b856150a2c0b4b872e0f9ae851385ceb542bfdad2330a49a4fb172ae715.jpeg",
    "https://cdn.faire.com/fastly/7020fa6b13d3ad8a1e5b14a2a1d87192b33de485156e5f53fd0ae9bc606e6d7b.jpeg",
  ],
  priceDollars: 7,
  description:
    "Let's go old school and trade recipes! A hand-written recipe card creates memories, legacies, even! Generations to come will know what yumminess you experienced, and what handwriting used to look like!\n\nSet of 12 recipe cards",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:15.056Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
